<template>
  <div class="otherAdd">
    <el-form :model="form" label-width="80px" :inline="true"  class="demo-form-inline">
      <el-form-item label="费用编号:">
        <el-input v-model="form.Waybill" size="mini" placeholder="请输入运单编号"></el-input>
      </el-form-item>
      <el-form-item label="费用类型:">
        <el-select v-model="form.costType" filterable size="mini" placeholder="请输入运单编号">
          <el-option v-for="item in costOptions" :key="item.value" :value="item.value" :label="item.name"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button size="small" class="searchBtn" @click="searchBtn">查询</el-button>
        <el-button size="small" class="resetBtn" @click="resetBtn">重置</el-button>
      </el-form-item>
    </el-form>
    <div>
      <el-table
        v-loading="tableLoad"
        :data="TableDatas"
        style="width: 100%"
        border
        tooltip-effect="dark"
        ref="otherAddRef"
        @select="handleCurrentChange"
        @select-all="handleCurrentChange"
        :reserve-selection="true"
        :header-cell-style="{background:'#E8E8E8',color:'#3B3B3B'}"
      >
        <el-table-column  type="selection" align="center" width="70px">
        </el-table-column>
        <el-table-column prop="costNum" label="费用编号" min-width="140" align="center"/>
        <el-table-column prop="costTypeName" label="费用类型" align="center"/>
        <el-table-column prop="costInstruction" label="费用说明" align="center" />
        <el-table-column prop="costTime" label="费用时间" min-width="140" align="center" >
          <template slot-scope="scope">{{scope.row.costTime|formatTime}}</template>
        </el-table-column>
        <el-table-column prop="taxRate" label="税率(%)" align="center"/>
        <el-table-column prop="costAmount" label="含税价" align="center" />
        <el-table-column prop="excludingTaxAmount" label="不含税价" align="center" />

      </el-table>
      <div class="paginationContainer" style="margin-top: 20px">
        <el-pagination
          background
          :page-sizes="[10, 20, 30, 40]"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          @size-change="contractSizeChange"
          @current-change="contractCurrentChange"
          :current-page.sync="form.page"
          :page-size="form.rows"
        />
      </div>
    </div>
  </div>
</template>

<script>
    import {othercostGetAllByCompanyId} from "@/service/getData";
    import {formatTime} from "@/config/mUtils";

    export default {
      name: "otherAdd",
      props:{
        otherDateProps:{
          default: []
        },
        consignorId:{
          default: ''
        }
      },
      data() {
        return {
          form:{
            Waybill:'',
            costType:'',
            page:1,
            rows:10,
          },
          total:0,
          costOptions: [{name:'全部',value:''}],
          tableLoad:false,
          TableDatas:[],
        }
      },
      filters:{
        formatTime(val){
          if(val){
            return formatTime(val, "yyyy-mm-dd hh:ii:ss")
          }else {
            return ''
          }
        },
      },
      methods: {
        //  分页查询 父组件调用
        async _othercostGetAllByCompanyId(){
          let {Waybill,costType} = this.form
          let obj = {
            companyId: this.consignorId,
            costNum:Waybill,
            costTypeId:costType,
          }
          this.tableLoad=true
          let res =await  othercostGetAllByCompanyId(obj)
          this.tableLoad=false
          if (res.status !==0) return this.$message.error(res.message)
          this.total = res.data.total
          this.TableDatas = res.data.records
          //因为重新请求了数据，重新回显
          this.toggleSelection()

        },
        searchBtn(){
          this.form.page = 1;
          this._othercostGetAllByCompanyId()
        },
        resetBtn(){
          for (const argumentsKey in this.form) {
            this.form[argumentsKey] = ""
          }
          this.form.page = 1
          this.form.rows = 10

        },
        //多选表格勾选触发
        handleCurrentChange(val){
          // this.otherDateProps =val
          console.log(val)
          console.log( this.otherDateProps)
          //将选中的数据，传给父组件
          this.$emit('otherDataCelect',val)
        },
        contractSizeChange(row){
          this.form.rows=row;
          this._othercostGetAllByCompanyId()
        },
        contractCurrentChange(page){
          this.form.page=page;
          this._othercostGetAllByCompanyId()
        },
        // 父组件调动函数 父组件子组件多选表格联动 重新勾选
        toggleSelection(){
          //清空勾选
          this.$refs.otherAddRef.clearSelection()
          this.$nextTick(()=>{
            //将数据循环筛选
            //otherDateProps  父组件传入数据  id相同就勾选
            this.otherDateProps.forEach((value,index)=>{
              this.$refs.otherAddRef.toggleRowSelection(this.TableDatas.find(item=>{
                return value.id ===item.id
              }))
            })
          })

        },
      }
    }
</script>

<style lang="scss" scoped>
  .otherAdd{
    padding: 20px;
  ::v-deep{
    .el-table__header .has-gutter tr .el-table-column--selection .cell .el-checkbox::after{
      color: #606266;
      content: "全选";
      font-size: 12px;
      margin-left: 2px;

    }
    .el-table td{ padding:0px; }
    .el-table th { padding:5px; }
    .cell{
      font-size: 10px;
      padding:0;
    }
  }

  }
</style>
